<template>
	<div>
		<!-- 顶部欢迎及注册登录按钮导航 -->
		<header-top />
		<!-- 顶部公司logo及导航栏 -->
		<logo-head></logo-head>
		<!-- 导航栏 -->
		<nav-head></nav-head>
		<!-- 背景贴图及分类导航 -->
		<div class="bgNav"  :style="{'background-image':'url('+ headImg +')'}">
			<div class="leftNav">
				<!-- 左侧导航 -->
				<div class="leftNavContent">
					<!-- 标题 -->
					<div class="headtitle">专利分类</div>
					<!-- 分类列表 -->
					<div class="headtitle" @click="goList(9,'医疗/保健/美容','')">
						<span class="iconfont icon-yiyongcailiao_haocai text-danger" style="font-size: 24px;"></span>
						<span style="font-size: 15px;" class="pl-2">医疗/保健/美容</span>
					</div>
					<div class="headtitle" @click="goList(8,'通信/电子/数码','')">
						<span class="iconfont icon-xiaofeidianzi text-primary" style="font-size: 24px;"></span>
						<span style="font-size: 15px;" class="pl-2">通信/电子/数码</span>
					</div>
					<div class="headtitle" @click="goList(7,'服饰/日用/家电','')">
						<span class="iconfont icon-shenghuoyongpin text-warning" style="font-size: 24px;"></span>
						<span style="font-size: 15px;" class="pl-2">服饰/日用/家电</span>
					</div>
					<div class="headtitle" @click="goList(1,'农林渔牧/食品','')">
						<span class="iconfont icon-nonglinyumu text-success" style="font-size: 24px;"></span>
						<span style="font-size: 15px;" class="pl-2">农林渔牧/食品</span>
					</div>
					<div class="headtitle" @click="goList(0,'','')">
						<span style="font-size: 18px;" class="pl-1">查看更多</span>
					</div>
				</div>
			</div>
		</div>
		<!-- 热门专利 -->
		<div class="hotPatent">
			<ModuleTitle titleName="发明,外观,实用新型专利推荐" titleEngName="Invention, appearance, utility model patent" class="pt-4"></ModuleTitle>
			<!-- 发明专利 -->
			<div class="faming">
				<div class="content">
					<el-row :gutter="20">
						<el-col :span="16">
							<el-row :gutter="20">
								<el-col :span="24" class="pb-4">
									<el-card class="box-card" shadow="never"
									style="--el-card-padding: 0px;border: none;--el-card-border-color:#fff;min-height: 343px;">
										<template #header>
										  <div class="card-header bg-white my-2">
											<span>发明专利</span>
											<span class="button"
											 style="color: #999;cursor: pointer;" @click="goList(12,'','发明专利')">更多专利</span>
										  </div>
										</template>
										<div class="d-flex" style="justify-content:space-around;margin-top: 10px;">
											<div v-for="(item,index) in fmPatent" class="hot_card_list" :key="index">
												<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" 
												:price="item.chargeAmount" v-show="index < 3"
												@click="goodsShow(item.id,'专利交易','/patent')"></show-card>
											</div>
										</div>
									</el-card>
								</el-col>
								<el-col :span="24">
									<el-card class="box-card" shadow="never"
									style="--el-card-padding: 0px;border: none;--el-card-border-color:#fff;min-height: 343px;">
										<template #header>
										  <div class="card-header bg-white my-2">
											<span>实用新型专利</span>
											<span class="button"  style="color: #999;cursor: pointer;"  @click="goList(13,'','实用新型专利')">更多专利</span>
										  </div>
										</template>
										<div class="d-flex" style="justify-content:space-around;margin-top: 10px;">
											<div v-for="(item,index) in syxxPatent" class="hot_card_list" :key="index">
												<show-card :imgUrl="item.logoUrl" 
												:titleDesc="item.name" :price="item.chargeAmount" v-show="index < 3"
												@click="goodsShow(item.id,'专利交易','/patent')"></show-card>
											</div>
										</div>
									</el-card>
								</el-col>
							</el-row>
						</el-col>
						<el-col :span="8">
							<el-card class="box-card" shadow="never" style="--el-card-padding: 0px;border: none;--el-card-border-color:#fff;min-height: 707px;">
								<template #header>
								  <div class="card-header bg-white my-2">
									<span>外观专利</span>
									<span class="button" style="color: #999;cursor: pointer;" @click="goList(14,'','外观专利')">更多专利</span>
								  </div>
								</template>
								<div class="d-flex" 
								style="flex-direction:column;align-items: center;justify-content: space-around;margin: 10px 20px;">
									<div v-for="(item,index) in wgPatent" class="hot_card_list mb-4" :key="index">
										<horizontal-card :imgUrl="item.logoUrl" :title="item.name" :price="item.chargeAmount"
										v-show="index < 4" @click="goodsShow(item.id,'专利交易','/patent')"></horizontal-card>
									</div>
								</div>
							</el-card>
						</el-col>
					</el-row>
				</div>
			</div>
		</div>
		<!-- 专利模块 -->
		<div class="patentContent">
			<div class="patentRightContent">
				<div class="leftImg position-relative">
					<div style="width: 272px;height: 520px;background-color:#000;
					z-index: 999;opacity: 0.4;position: absolute;left:0;bottom: 0;">
						<div class="mt-5 ml-4" style="z-index: 99999999999;color: #fff;">
							<span class="text-white">{{userMenuName}}</span>
						</div>
					</div>
				</div>
				<div class="rightContent">
					<div v-for="(item,index) in userMenu" class="hot_card_list mb-4" :key="index">
						<show-card :imgUrl="item.logoUrl" :titleDesc="item.name" :price="item.chargeAmount" v-show="index < 8"
						@click="goodsShow(item.id,'专利交易','/patent')"></show-card>
					</div>
					<show-card imgUrl=""  titleDesc="待加入..." :price="'￥9999'" v-show="userMenu.length < 8"
					v-for="i in 8 - userMenu.length" :key="i"></show-card>
					<img src="">
				</div>
			</div>
		</div>
		<!-- 专利求购 -->
		<div class="patentPurchaseOutContent">
			<div class="patentPurchase">
				<popular-tab titleName="专利求购" moreLinkUrl="/purchaseList" linkFrom="patent" type="专利">
					<div class="mt-3 d-flex" style="justify-content: space-between;">
						<div style="width: 285px;height: 180px;background-color: #fff;border: 1px solid #eee;cursor: pointer;"
						v-for="(item,index) in patentWantBuyArr" :key="index" @click="detailShow(item.id,'专利求购','/purchaseList','专利')">
							<!-- 上半部分信息描述 -->
							<div class="descTop border-bottom p-3" style="height:150px;">
								<!-- 标题 -->
								<span style="color: #666;font-size: 16px;font-weight: bold;">{{item.name}}</span>
								<!-- 预算资金 -->
								<p style="color: #666;font-size: 14px;">￥{{item.money}}</p>
								<!-- 发布时间 -->
								<p>{{item.createAt}}</p>
							</div>
							<!-- 下半部分发布者 -->
							<div class="authorBottom pl-3 pt-1" style="height: 30px;font-size: 14px;">
								发布者：{{item.userName}}
							</div>
						</div>
					</div>
				</popular-tab>
			</div>
		</div>
		<!-- 交易流程图 -->
		<div class="process">
			<ModuleTitle titleName="交易流程" titleEngName="Transaction process" class="pt-4"></ModuleTitle>
			<div class="text-center pt-4">
				<img src="../../assets/img/home/首页流程图.png" width="1200">
			</div>
		</div>
		<!-- 底部导航 -->
		<div>
			<Footer></Footer>
		</div>
	</div>
</template>

<script>
	import {
		ref,
	} from 'vue'
	import HeaderTop from '@/components/headerTop/headerTop.vue'
	import LogoHead from '@/components/logoHead/logoHead.vue'
	import NavHead from '@/components/navHead/navHead.vue'
	import showCard from '@/components/showCard/showCard.vue'
	import PopularTab from '@/components/popularTab/popularTab.vue'
	import horizontalCard from '@/components/showCard/horizontalCard.vue'
	import ModuleTitle from '@/components/moduleTitle/moduleTitle.vue'
	import Footer from '@/components/footer/footer.vue'
	export default{
		components: {
			HeaderTop,
			LogoHead,
			NavHead,
			showCard,
			PopularTab,
			horizontalCard,
			ModuleTitle,
			Footer
		},
		setup() {
			// 发明专利
			let fmPatent = ref([])
			// 外观专利
			let wgPatent = ref([])
			// 实用新型
			let syxxPatent = ref([])
			// 自定义模块
			let userMenu = ref([])
			// 自定义模块名
			let userMenuName = ref('')
			let headImg = ref('')
			// 想买专利
			let patentWantBuyArr = ref([])
			return {
				fmPatent,
				wgPatent,
				syxxPatent,
				patentWantBuyArr,
				userMenu,
				userMenuName,
				headImg
			}
		},
		mounted() {
			// 获取热门推荐-热门专利数据
			this.getHotPatent()
			this.getSyxxPatent()
			this.getWgPatent()
			this.getUserMenu()
			// 获取头部背景图
			this.getHeadImg()
			this.getPatentWantBuyArr()
		},
		methods: {
			// 获取热门推荐-发明专利
			getHotPatent(){
				let vm = this
				this.axios.get('/api/patent/findHotPatentByType',{params:{type:"发明专利",count:3}}).then(res => {
					vm.fmPatent = res.data.data
				})
			},
			// 获取热门推荐-实用新型专利
			getSyxxPatent(){
				let vm = this
				this.axios.get('/api/patent/findHotPatentByType',{params:{type:"实用新型专利",count:3}}).then(res => {
					vm.syxxPatent = res.data.data
				})
			},
			// 获取热门推荐-外观专利
			getWgPatent(){
				let vm = this
				this.axios.get('/api/patent/findHotPatentByType',{params:{type:"外观专利",count:4}}).then(res => {
					vm.wgPatent = res.data.data
				})
			},
			// 获取自定义菜单
			getUserMenu(){
				let vm = this
				this.axios.get('/api/patent/findHotPatentRecommend').then(res => {
					vm.userMenu = res.data.data.results
					vm.userMenuName = res.data.data.name
				})
			},
			// 获取专利求购模块
			getPatentWantBuyArr(){
				let vm = this
				this.axios.get('/api/want/buy/findAll',{params:{
					type:'专利',
					everySize:4,
					currPage:1
				}}).then(res => {
					vm.patentWantBuyArr = res.data.data.wantBuys
				})
			},
			// 获取头部背景图
			getHeadImg(){
				let vm = this
				this.axios.get('/api/material/findMaterial').then(res => {
					vm.headImg = res.data.data.patentUrl
				})
			},
			// 进入商品详情页
			goodsShow(id,mbx,mbxLink){
				let routeData = this.$router.resolve({
					path:'/goodsInfo',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:'patent'
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 进入专利求购详情页
			detailShow(id,mbx,mbxLink,type){
				let routeData = this.$router.resolve({
					path:'/purchaseDetail',
					query:{
						id:id,
						mbx:mbx,
						mbxLink:mbxLink,
						type:type
					}
				})
				window.open(routeData.href, '_blank');
			},
			// 前往商标详情页列表
			goList(typeId,selectName,selectType){
				this.$router.push({
					name:'patentList',
					params:{
						id:0,
						typeId:typeId,
						selectType:selectType,
						selectName:selectName
					}
				})
			}
		},
	}
</script>

<style scoped>
	.bgNav{
		width: 100%;
		height: 550px;
		background-color: #eee;
		background-size:100% 100%;
		background-repeat: no-repeat;
	}
	.bgNav>.leftNav{
		width: 1200px;
		height: 300px;
		margin: 0 auto;
		position: relative;
		top:20px;
	}
	.leftNav .leftNavContent{
		width: 240px;
		height: 360px;
		background-color: #fff;
		border-radius: 20px;
		position: relative;
		top:50px
	}
	.leftNav .leftNavContent .headtitle{
		width: 240px;
		height: 60px;
		text-align: center;
		line-height: 60px;
		color: #333;
		font-size: 18px;
	}
	.leftNav .leftNavContent .headtitle:not(:last-child){
		border-bottom: 1px solid #eee;;
	}
	.leftNav .leftNavContent .headtitle:hover{
		color: #C32A1A;
		cursor: pointer;
	}
	/* 热门专利 */
	.hotPatent{
		width: 100%;
		min-height: 850px;
		background-color: #F8F8F8;
	}
	.faming .content{
		width: 1200px;
		min-height:710px;
		margin: 0 auto;
		margin-top:30px;
	}
	.card-header {
	  display: flex;
	  justify-content: space-between;
	  align-items: center;
	}
	/* 	横排8个 */
	.patentContent{
		width: 100%;
		height:560px;
		background-color: #F8F8F8;
		overflow: hidden;
	}
	.patentContent .rightContent{
		width: 913px;
		display: flex;
		flex-wrap: wrap;
		justify-content: space-between;
	}
	.patentContent .patentRightContent .leftImg{
		width:272px;
		height:520px;
		background-image:url(../../assets/img/home/patentBottomLeftImg.jpg);
		background-size:100% 100%;
		margin-right:15px;
	}
	.patentContent .patentRightContent .leftImg span{
		font-size: 20px;
		font-weight: bold;
	}
	.patentRightContent{
		width: 1200px;
		height: 550px;
		margin: 0 auto;
		display: flex;
		margin-top: 30px;
	}
	/* 专利求购 */
	.patentPurchaseOutContent{
		width: 100%;
		min-height:300px;
		overflow: hidden;
		background-color: #f8f8f8;
	}
	.patentPurchase{
		width: 1200px;
		height: 250px;
		margin: 0 auto;
		margin-top: 30px;
	}
	/* 交易流程 */
	.process{
		width: 100%;
		margin-bottom:38px;
	}
	.hot_card_list{
		cursor: pointer;
	}
</style>
